import { render } from "./TransactionRecords.vue?vue&type=template&id=48facf1d"
import script from "./TransactionRecords.vue?vue&type=script&lang=js"
export * from "./TransactionRecords.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__